import { render, staticRenderFns } from "./IconFolderAddSolid.vue?vue&type=template&id=52c2acb7"
import script from "./IconFolderAddSolid.vue?vue&type=script&lang=js"
export * from "./IconFolderAddSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports